import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="w-full bg-midnight py-24 px-6" data-id="element-166">
      <div className="max-w-3xl mx-auto text-center relative" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="absolute -top-12 left-1/2 -translate-x-1/2 text-cyan-signal/10 font-display text-9xl leading-none select-none" data-id="element-168">
          "
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative z-10" data-id="element-169">
          <p className="text-2xl md:text-3xl text-bone font-body italic leading-relaxed mb-8" data-id="element-170">
            En los primeros 7 días, notarás que la "niebla mental" de las 10:00
            AM desaparece. No es magia, es{' '}
            <span className="text-cyan-signal font-bold not-italic" data-id="element-171">
              neuroquímica básica
            </span>
            : cuando el cortisol baja y la temperatura central cae, el sueño
            profundo es inevitable.
          </p>
        </motion.div>
      </div>
    </section>;
}